module.exports = __webpack_public_path__ + "static/img/icon20_index.78fa505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon20_index.png
// module id = zo72
// module chunks = 1